import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

/**
 * @param {object} contact
 * @param {string} siteId
 * @param {string} contact.name
 * @param {string} contact.email
 * @param {string} contact.phoneNumber
 * @param {boolean} contact.highTemperatureEmail
 * @param {boolean} contact.failedWashEmail
 * @param {boolean} contact.malfunctionsEmail
 * @param {boolean} contact.changeSoapEmail
 * @param {boolean} contact.highTemperatureSms
 * @param {boolean} contact.failedWashSms
 * @param {boolean} contact.malfunctionsSms
 * @param {boolean} contact.changeSoapSms
 */
export default (contact, siteId) => {
  const endpoint = `${apiEndpoints.sites}/${siteId}/contacts`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.post(URL, contact, { withCredentials: true }))
}
